import * as React from 'react'
import { styled } from 'next-yak'

import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'
import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'

const ID = 'dailymotion-third-party-glyph-icon'

export function DailymotionSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <g>
        <path
          fillRule="evenodd"
          d="M16.658 24.044c-1.105 1.097-2.488 1.645-4.152 1.645-1.636 0-2.992-.535-4.07-1.605-1.077-1.07-1.615-2.446-1.615-4.13 0-1.605.552-2.936 1.656-3.992 1.105-1.056 2.461-1.584 4.07-1.584 1.09 0 2.08.247 2.966.742a5.318 5.318 0 0 1 2.065 2.025c.491.856.736 1.792.736 2.808 0 1.631-.552 2.995-1.656 4.091Zm1.288-22.541v9.305c-.954-.936-1.97-1.61-3.047-2.025-1.077-.415-2.284-.622-3.62-.622-2.154 0-4.09.521-5.808 1.564-1.718 1.043-3.054 2.467-4.009 4.272C.508 15.802.031 17.8.031 19.993c0 2.246.47 4.272 1.41 6.077a10.622 10.622 0 0 0 4.01 4.272c1.731 1.043 3.715 1.564 5.95 1.564 3.246 0 5.51-1.043 6.79-3.129h.082v2.852h6.463V.06l-6.79 1.444Z"
          clipRule="evenodd"
        />
      </g>
    </symbol>
  )
}

const DailymotionStandaloneContent = standalone(DailymotionSymbol, ID)

export const Dailymotion = styled(function DailymotionStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-dailymotion">
      <DailymotionStandaloneContent />
    </Icon>
  )
})``

export const DailymotionLightweight = styled(function DailymotionComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-dailymotion">
      {lightweight(ID)}
    </Icon>
  )
})``
